export class TimeLineItemDTO {
	familyId: string
	departureTime: string
	departurePlace: string
	arrivalTime: string
	arrivalPlace: string
	travelTime: string
	transitTime?: string
	constructor(
		familyId: string,
		departureTime: string,
		departurePlace: string,
		arrivalTime: string,
		arrivalPlace: string,
		travelTime: string,
		transitTime?: string
	) {
		this.familyId = familyId
		this.departureTime = departureTime
		this.departurePlace = departurePlace
		this.arrivalTime = arrivalTime
		this.arrivalPlace = arrivalPlace
		this.travelTime = travelTime
		this.transitTime = transitTime
	}
}

export class FullTransportTimeLineResponseDTO {
	forwardTimeLine: TimeLineItemDTO[]
	returnTimeLine: TimeLineItemDTO[]
	constructor(
		forwardTimeLine: TimeLineItemDTO[],
		returnTimeLine: TimeLineItemDTO[]
	) {
		this.forwardTimeLine = forwardTimeLine
		this.returnTimeLine = returnTimeLine
	}
}
